import { Info } from 'lucide-react'
import { Suspense } from 'react'

import { useUserById } from '../../../api/accounts/use-user-by-id'

const NoTransactionDisclaimerSkeleton = () => {
  return (
    <div className="flex flex-row items-center gap-1">
      <Info className="size-4 text-muted" />
      <p className="text-sm text-muted">{'User'}&apos;s transaction list is private</p>
    </div>
  )
}

const NoTransactionDisclaimerContent = ({ userId }: { userId: number }) => {
  const { data: user } = useUserById(userId)
  return (
    <div className="flex flex-row items-center gap-1">
      <Info className="size-4 text-muted" />
      <p className="text-sm text-muted">{user?.fullName || 'User'}&apos;s transaction list is private</p>
    </div>
  )
}

const NoTransactionDisclaimer = ({ userId }: { userId: number }) => {
  return (
    <Suspense fallback={<NoTransactionDisclaimerSkeleton />}>
      <NoTransactionDisclaimerContent userId={userId} />
    </Suspense>
  )
}

export default NoTransactionDisclaimer
